/*
 * HumedisityLink.jsx — tarjeta de acceso a Humedisity (peritaje IA de incidencias).
 *
 * Humedisity es una app externa que ya usa LiveWifi/Adquiriam. Se enlaza como
 * app hermana: pasamos el código del site como query param para que el técnico
 * pueda abrir la incidencia en Humedisity y volver.
 */
import React from 'react';
import { ExternalLink, Droplets, ShieldCheck } from 'lucide-react';

const HUMEDISITY_URL = 'https://humidity-detective.emergent.host';

const HumedisityLink = ({ siteCode, compact = false }) => {
  const url = siteCode
    ? `${HUMEDISITY_URL}/?site=${encodeURIComponent(siteCode)}`
    : HUMEDISITY_URL;

  if (compact) {
    return (
      <a href={url} target="_blank" rel="noreferrer"
        data-testid="humedisity-link-compact"
        className="inline-flex items-center gap-1.5 bg-blue-500/15 border border-blue-500/30 text-blue-300 hover:bg-blue-500/25 text-xs font-black px-3 py-1.5 rounded-lg">
        <Droplets size={12}/> Peritar en Humedisity <ExternalLink size={10}/>
      </a>
    );
  }

  return (
    <div className="bg-gradient-to-br from-blue-500/10 to-cyan-500/5 border border-blue-500/30 rounded-2xl p-5" data-testid="humedisity-card">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <Droplets className="text-blue-400" size={18}/>
            <span className="text-[10px] font-black tracking-widest text-blue-300">PERITAJE ADQUIRIAM · HUMEDISITY</span>
          </div>
          <div className="text-white font-black text-lg">Diagnóstico de incidencias</div>
          <p className="text-white/60 text-sm mt-1 leading-relaxed">
            Checklist completo del emplazamiento, plano de cubierta y motor de reglas + Adquiriam para
            detectar humedades, daños, conservación, limpieza, equipos y vandalismo.
          </p>
          <div className="flex items-center gap-1.5 flex-wrap mt-2">
            {['Humedad', 'Daños', 'Conservación', 'Limpieza', 'Equipos', 'Vandalismo'].map((t) => (
              <span key={t} className="text-[9px] font-black px-2 py-0.5 rounded-full bg-white/5 text-white/60 border border-white/10">
                {t}
              </span>
            ))}
          </div>
        </div>
        <ShieldCheck className="text-blue-400/50 flex-shrink-0 hidden sm:block" size={26}/>
      </div>
      <a href={url} target="_blank" rel="noreferrer"
        data-testid="humedisity-open"
        className="mt-4 inline-flex items-center gap-2 bg-blue-500 text-white font-black text-sm px-4 py-2 rounded-lg hover:bg-blue-400">
        Abrir Humedisity <ExternalLink size={14}/>
      </a>
    </div>
  );
};

export default HumedisityLink;
